import { SettingsActions } from '@lmt/unicorn-shared/app/features/settings/reducer';
import { getSettings } from '@lmt/unicorn-shared/app/features/settings/selectors';
import {
  useUniDispatch,
  useUniSelector,
} from '@lmt/unicorn-shared/app/store/types';
import React, { useCallback, useEffect } from 'react';
import { ToggleButton } from '../../common/ui-kit/ToggleButton';
import styles from './NightThemeToggle.module.scss';

interface Props {
  isToollbar?: boolean;
}

export const NightThemeToggle: React.FC<Props> = (props) => {
  const dispatch = useUniDispatch();
  const isNightTheme = useUniSelector(getSettings).isNightTheme;
  const сhangeNightThemeSettings = useCallback((checked: boolean) => {
    dispatch(SettingsActions.isNightThemeChanged(checked));
  }, []);

  return (
    <div className={styles.container}>
      {props.isToollbar && <div className={styles.text}>Night theme</div>}
      <ToggleButton
        name={'night_theme_toggle'}
        checked={isNightTheme ?? false}
        title={''}
        onChange={(e) => сhangeNightThemeSettings(e.currentTarget.checked)}
      />
    </div>
  );
};
